export default __webpack_public_path__ + "static/media/subscription_registration.06ac8248.png";